import React, { useState, useEffect } from "react";

const buildImgixSrc = (src, imgixParams, w, h) =>
  `${src}?auto=format,compress${
    imgixParams.q ? "&q=" + imgixParams.q : "&q=20"
  }${imgixParams.fit ? "&fit=" + imgixParams.fit : ""}${
    imgixParams.crop ? "&crop=" + imgixParams.crop : ""
  }${w ? "&w=" + w : ""}${h ? "&h=" + h : ""}`;

const ImgixImg = ({ src, imgixParams }) => {
  const [newSrc, setNewSrc] = useState("");
  const [newSrcSet, setNewSrcSet] = useState("");
  const [newSizes, setNewSizes] = useState("");

  useEffect(() => {
    // Static breakpoint mode: several width candidates + a `sizes` attribute,
    // so the browser picks the right one from CSS media conditions (no JS
    // window-width readout).
    if (imgixParams.sizes) {
      const heightFor = (w) =>
        imgixParams.ratio ? Math.round(w * imgixParams.ratio) : imgixParams.h;
      const fallbackWidth =
        imgixParams.sizes[imgixParams.sizes.length - 1].width;

      setNewSrc(
        buildImgixSrc(src, imgixParams, fallbackWidth, heightFor(fallbackWidth))
      );
      setNewSrcSet(
        imgixParams.sizes
          .map(
            ({ width }) =>
              `${buildImgixSrc(
                src,
                imgixParams,
                width,
                heightFor(width)
              )} ${width}w`
          )
          .join(", ")
      );
      setNewSizes(
        imgixParams.sizes
          .map(({ minWidth, width }) =>
            minWidth ? `(min-width: ${minWidth}px) ${width}px` : `${width}px`
          )
          .join(", ")
      );
      return;
    }

    const singleSrc = buildImgixSrc(
      src,
      imgixParams,
      imgixParams.w,
      imgixParams.h
    );
    setNewSrc(singleSrc);
    setNewSrcSet(singleSrc + "&dpr=1 1x, " + singleSrc + "&dpr=2 2x");
  }, []);

  return <img src={newSrc} srcSet={newSrcSet} sizes={newSizes || undefined} />;
};

export default ImgixImg;
